<template>
  <div>
    <v-row>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <!--<router-link :to="{ name: '' }">
        <v-btn class="ma-2" outlined color="indigo">
          <v-icon>mdi-plus</v-icon>
          Set Delivery
        </v-btn>
      </router-link> -->
      </v-toolbar>
    </v-row>
    <v-row>
      <v-col cols="12">
        <delivery-order-list :type_view="access_type" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const deliveryOrderList = () => import("@/components/traffic/dos-listings");
const deliveryOrderNamespace = createNamespacedHelpers("delivery_orders");

export default {
  components: {
    deliveryOrderList
  },
  data() {
    return {
      tabs: null,
      text: "",
      access_type: "delivery"
    };
  },
  computed: {
    ...deliveryOrderNamespace.mapState({
      action_menu_view: state => state.action_menu_view
    })
  },
  mounted() {
    this.initialize();
  },
  methods: {
    ...deliveryOrderNamespace.mapActions(["asetActionMenuView"]),

    initialize() {
      //this.asetActionMenuView(this.access_type);
    }
  }
};
</script>

<style>
a {
  text-decoration: none;
}
</style>
